// extracted by mini-css-extract-plugin
module.exports = {"title":"HistoryItem_title__3RTwA","time":"HistoryItem_time__1aO-Q","note":"HistoryItem_note__2ZxPl","noteLink":"HistoryItem_noteLink__1d5OR","subNote":"HistoryItem_subNote__1wSvA"};